import * as helpers from '../helpers';
function useEchoHelpers() {
    return helpers;
}
export default useEchoHelpers;
//# sourceMappingURL=useEchoHelpers.js.map